export const DATA_TYPE = {
  LISTENING: 'listening',
  SAC: 'sac',
  PAGE: 'page',
  COMPETITIVE: 'competitive',
  SAC_STATUS: 'sac-status',
  BLIP: 'blip',
  SAC_LISTENING: 'sac-listening',
  CUSTOM: 'custom',
  STATIC: 'static',
};

export const SUBDATA_TYPE = {
  BLIP: {
    CONTACTS: 'contacts',
    MESSAGES: 'messages',
    ACTV_MESSAGES: 'active-messages',
    HUMAN_SERVICE: 'human-service',
    EVENTS: 'event-track',
  },
};

export const SUBDATA_TYPE_LABEL = {
  [SUBDATA_TYPE.BLIP.CONTACTS]: 'Contatos',
  [SUBDATA_TYPE.BLIP.MESSAGES]: 'Mensagens',
  [SUBDATA_TYPE.BLIP.ACTV_MESSAGES]: 'Mensagens ativas',
  [SUBDATA_TYPE.BLIP.EVENTS]: 'Registro de eventos',
  [SUBDATA_TYPE.BLIP.HUMAN_SERVICE]: 'Atendimento humano',
};

export const DATA_TYPE_INITIALS = {
  [DATA_TYPE.LISTENING]: 'SL',
  [DATA_TYPE.SAC]: 'MP',
  [DATA_TYPE.PAGE]: 'MP',
  [DATA_TYPE.SAC_STATUS]: 'SC',
  [DATA_TYPE.COMPETITIVE]: '',
  [DATA_TYPE.BLIP]: 'BLIP',
  [DATA_TYPE.SAC_LISTENING]: 'PNP',
  [DATA_TYPE.CUSTOM]: 'PSLZ',
  [DATA_TYPE.STATIC]: '',
};

export const DATA_TYPE_TOOLTIP = {
  [DATA_TYPE.LISTENING]: 'Social Listening',
  [DATA_TYPE.SAC]: 'Métricas Proprietárias',
  [DATA_TYPE.PAGE]: 'Métricas Proprietárias',
  [DATA_TYPE.SAC_STATUS]: 'Smart Care',
  [DATA_TYPE.COMPETITIVE]: '',
  [DATA_TYPE.BLIP]: 'BLIP',
  [DATA_TYPE.SAC_LISTENING]: 'Proprietários + Não Proprietários',
  [DATA_TYPE.CUSTOM]: 'Personalizados',
  [DATA_TYPE.STATIC]: '',
};

export const DATA_TYPE_LABEL = {
  [DATA_TYPE.LISTENING]: 'Dados não-proprietários',
  [DATA_TYPE.SAC]: 'Dados proprietários',
  [DATA_TYPE.PAGE]: 'Métricas das páginas',
  [DATA_TYPE.BLIP]: 'BLIP',
  [DATA_TYPE.SAC_LISTENING]: 'Proprietários + Não Proprietários',
  [DATA_TYPE.CUSTOM]: 'Personalizados',
  [DATA_TYPE.STATIC]: 'Complementares',
  [DATA_TYPE.SAC_STATUS]: 'Smart Care',
};

export const DATA_TYPE_FILTERS_METHODS_OPTIONS = {
  [DATA_TYPE.LISTENING]: 'openFilterListeningModal',
  [DATA_TYPE.SAC]: 'openFilterSacModal',
  [DATA_TYPE.PAGE]: 'openFilterPageMetricsModal',
  [DATA_TYPE.COMPETITIVE]: 'openFilterCompetitiveModal',
  [DATA_TYPE.SAC_STATUS]: 'openFilterSacStatusModal',
  [DATA_TYPE.SAC_LISTENING]: 'openFilterSacListeningModal',
  [DATA_TYPE.BLIP]: 'openFilterBlipModal',
};

export const WIDTH = {
  SMALL: 2,
  MID: 3,
  LARGE: 4,
  COL5: 5,
  XLARGE: 6,
  COL7: 7,
  COL8: 8,
  COL9: 9,
  COL10: 10,
  COL11: 11,
  COL12: 12,
};

export const HEIGHT = {
  AUTO: 'auto',
  SMALL: 4,
  MID: 6,
  LARGE: 8,
  XLARGE: 12,
};

export const DEFAULT_SIZES = {
  simpleNumber: {
    width: WIDTH.SMALL,
    height: HEIGHT.SMALL,
  },
  pieChart: {
    width: WIDTH.MID,
    height: HEIGHT.MID,
  },
  lineChart: {
    width: WIDTH.XLARGE,
    height: HEIGHT.MID,
  },
  multiBarChart: {
    width: WIDTH.MID,
    height: HEIGHT.LARGE,
  },
};

export const WIDTH_SIZE_LABEL = {
  SMALL: '2 Colunas',
  MID: '3 Colunas',
  LARGE: '4 Colunas',
  COL5: '5 Colunas',
  XLARGE: '6 Colunas',
  COL7: '7 Colunas',
  COL8: '8 Colunas',
  COL9: '9 Colunas',
  COL10: '10 Colunas',
  COL11: '11 Colunas',
  COL12: '12 Colunas',
};

export const HEIGHT_SIZE_LABEL = {
  AUTO: 'Automático',
  SMALL: 'Pequeno',
  MID: 'Médio',
  LARGE: 'Grande',
  XLARGE: 'Extra grande',
};

export const FILTER_NAMES = {
  CHANNEL: 'channels',
  DARK_POST: 'dark_post',
  FAVORITE: 'favorite',
  GROUP: 'names',
  GENDER: 'genders',
  PAGES: 'pages',
  PIDS: 'pids',
  POLARITY: 'polarities',
  SAC_TYPE: 'sac_type',
  SAC_STATUS: 'sac_status',
  SAC_LAST_STATUS: 'sac_last_status',
  SAC_REPLIER: 'sac_replier',
  SAC_REPLIER_STATUS: 'sac_replier_status',
  RATING: 'rating',
  TEXT_QUERY: 'query',
  TAG: 'tags',
  THEME: 'themes',
  UIDS: 'uids',
  CONTRACTS: 'contracts',
  BOTS: 'bots',
  CATEGORY: 'category',
  CHANNELS_LISTENING: 'channels_listening',
  DOMAINS: 'domains',
  OPERATORS: 'operators',
  TEAMS: 'teams',
  DESK_TAGS: 'tags',
  LOVERS_HATERS: 'lovers_and_haters',
  REPLIED: 'replied',
  SCHEDULED: 'scheduled',
  CAMPAIGN_NAME: 'campaign_name',
  TAGS_VIEW: 'tags_view',
};

export const POST_ORDER = {
  ASC: 'date_asc',
  COMMENTS: 'comments',
  DESC: 'date_desc',
  HOT: 'hot',
  INFLUENCE: 'influence',
  INTERACTIONS: 'interactions',
  LIKES: 'likes',
  SHARES: 'shares',
};

export const VARIATION_TYPE = {
  UP: 'up',
  STAND: 'stand',
  DOWN: 'down',
};

export const CHANNELS_FILTER_TRANSLATE = {
  'tiktok': 'TikTok',
  'blip': 'Blip',
  'twitter': 'twitter',
  'linkedin': 'linkedin',
  'youtube': 'youtube',
};

export const CHANNELS_BLIP_CHAT = {
  '0mn.io': 'BLiP Chat',
  'messenger.gw.msging.net': 'Messenger',
  'workplace.gw.msging.net': 'Workplace',
  'telegram.gw.msging.net': 'Telegram',
  'mailgun.gw.msging.net': 'E-mail',
  'instagram.gw.msging.net': 'Instagram',
  'googlercs.gw.msging.net': 'Google RCS',
  'pagseguro.gw.msging.net': 'PagSeguro',
  'wa.gw.msging.net': 'Whatsapp',
  'assistant.gw.msging.net': 'Google Assistent',
  'abs.gw.msging.net': 'Azure Bot Service',
  'businesschat.gw.msging.net': 'Apple Messages for Business',
  'alexa.gw.msging.net': 'Amazon Alexa',
  'businessmessages.gw.msging.net': 'Google Business Messages',
};

export const COMPONENT_TYPE = {
  BUBBLE: 'bubble_chart',
  CARD: 'card_chart',
  DATA_TABLE: 'data_table_chart',
  DONUT: 'donut_chart',
  DUAL_AXIS: 'dual_axis_chart',
  GAUGE: 'gauge_chart',
  HORIZONTAL_BAR: 'horizontal_bar_chart',
  HORIZONTAL_GROUPED_BAR: 'horizontal_grouped_bar_chart',
  HORIZONTAL_STACKED_BAR: 'horizontal_stacked_bar_chart',
  IMAGE: 'image',
  IMPORT_FILE: 'import_file_chart',
  LINE: 'line_chart',
  NETWORK: 'network_chart',
  RANKING: 'ranking_chart',
  SEARCH: 'search_chart',
  SECTION: 'section',
  SINGLE_VALUE: 'single_value_chart',
  STACKED_AREA: 'stacked_area_chart',
  STACKED_LINE: 'stacked_line_chart',
  TEXT: 'text',
  VERTICAL_BAR: 'vertical_bar_chart',
  VERTICAL_GROUPED_BAR: 'vertical_grouped_bar_chart',
  VERTICAL_STACKED_BAR: 'vertical_stacked_bar_chart',
  WORD_CLOUD: 'word_cloud_chart',
};

export const COMPONENT_TYPE_BASED = {
  [COMPONENT_TYPE.LINE]: 'ComponentBuilderLineChart',
  [COMPONENT_TYPE.STACKED_LINE]: 'ComponentBuilderStackedLineChart',
  [COMPONENT_TYPE.VERTICAL_BAR]: 'ComponentBuilderColumnChart',
  [COMPONENT_TYPE.VERTICAL_STACKED_BAR]: 'ComponentBuilderStackedColumnChart',
  [COMPONENT_TYPE.HORIZONTAL_BAR]: 'ComponentBuilderBarChart',
  [COMPONENT_TYPE.HORIZONTAL_STACKED_BAR]: 'ComponentBuilderStackedBarChart',
  [COMPONENT_TYPE.DONUT]: 'ComponentBuilderPieChart',
  [COMPONENT_TYPE.SINGLE_VALUE]: 'ComponentBuilderDataWithVariation',
};

export const RATING_TYPE = {
  CES: {
    name: 'ces',
    maxRating: 7,
  },
  CSAT: {
    name: 'csat',
    maxRating: 5,
  },
  NPS: {
    name: 'nps',
    maxRating: 10,
  },
};
